import React, { useState, useEffect } from 'react';
import './App.css';
import Navigation from './components/Navigation/Navigation';
import Questionnaire from './components/Questionnaire/Questionnaire';
import Services from './components/Services/Services';
import useStyles from './App.style';
import PersonalData from './components/PersonalData/PersonalData';
import theme from './theme';
import { ThemeProvider } from '@mui/material/styles';
import download from './assets/svg/download.svg';
import contact from './assets/svg/contact.svg';

import Summary from './components/Summary/Summary';

import BasicDocument from './components/PdfDocument/PdfDocument';
import { PDFDownloadLink } from '@react-pdf/renderer';

// date-fns
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import TextField from '@mui/material/TextField';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const App = ({ children }) => {
  const [plannerStep, setPlannerStep] = useState(1);

  // kwestionariusz
  const [questionnaireData, setQuestionnaireData] = useState({
    target: '',
    peopleNumber: '',
    startDate: '',
    days: '',
    transport: '',
    ageGroup: '',
    meals: '',
    hotel: false,
    hotelStartDate: '',
    hotelEndDate: '',
  });

  // dane osobowe
  const [personalData, setPersonalData] = useState({
    name: '',
    surname: '',
    mail: '',
    phone: '',
    company: '',
    city: '',
    addInfo: '',
  });

  //koszyk
  const [cart, setCart] = useState([]);

  //next step button
  const [isFormValid, setIsFormValid] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    if (showAlert) {
      setShowAlert(!isFormValid);
    }
  }, [isFormValid]);

  function handleClick() {
    if (isFormValid) {
      if (plannerStep < 4) {
        setPlannerStep(plannerStep + 1);
      }
    } else {
      setShowAlert(true);
    }
  }

  function handleClickReturn() {
    if (plannerStep <= 4) {
      setPlannerStep(plannerStep - 1);
    }
  }

  function handleSendEnqiry() {
    console.log(cart);
    console.log(questionnaireData);
    console.log(personalData);
    var axios = require('axios');

    const data = new FormData();

    let cartString = '';
    for (const fieldCart in cart) {
      cartString =
        cartString +
        '\n - ' +
        'nazwa: ' +
        String(cart[fieldCart]['title'][0]) +
        ' ' +
        'cena: ' +
        String(cart[fieldCart]['price']) +
        ' ' +
        'pakiet: ' +
        String(cart[fieldCart]['package']) +
        ' ' +
        'id: ' +
        String(cart[fieldCart]['id']);
    }

    data.append('uslugi', cartString);

    for (const fieldQuestionnaireData in questionnaireData) {
      data.append(
        fieldQuestionnaireData,
        questionnaireData[fieldQuestionnaireData]
      );
    }
    for (const fieldPersonalData in personalData) {
      if (fieldPersonalData == 'name') {
        data.append('firstName', personalData[fieldPersonalData]);
      } else {
        data.append(fieldPersonalData, personalData[fieldPersonalData]);
      }
    }

    // var data = JSON.stringify({
    //   rehabilitation: rehabId,
    //   author_name: `${
    //       cookies.get('userData')['description']['data']['displayName']
    //   }`,
    //   content: commentContent,
    // });

    var config = {
      method: 'post',
      url:
        process.env.REACT_APP_WP_ADMIN_URL +
        'wp-json/contact-form-7/v1/contact-forms/1199/feedback',
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' },
    };

    axios(config)
      .then(function (response) {
        console.log(JSON.stringify(response.data));
        handleClick();
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  return (
    <ThemeProvider theme={theme}>
      <div className="container">
        <div className="row">
          <div className="col col-12">
            <Navigation navigationStep={plannerStep} />
          </div>
        </div>

        <div className="row">
          <div className="col col-12">
            <div className={classes.content}>
              {plannerStep === 1 ? (
                <Questionnaire
                  questionnaireData={questionnaireData}
                  setQuestionnaireData={setQuestionnaireData}
                  setIsFormValid={setIsFormValid}
                  showAlert={showAlert}
                />
              ) : (
                ''
              )}
              {plannerStep === 2 ? (
                <Services
                  peopleNumber={questionnaireData.peopleNumber}
                  cart={cart}
                  setCart={setCart}
                  setIsFormValid={setIsFormValid}
                />
              ) : (
                ''
              )}
              {plannerStep === 3 ? (
                <PersonalData
                  personalData={personalData}
                  setPersonalData={setPersonalData}
                  cart={cart}
                  setCart={setCart}
                  setIsFormValid={setIsFormValid}
                  showAlert={showAlert}
                />
              ) : (
                ''
              )}
              {plannerStep === 4 ? (
                <Summary
                  cart={cart}
                  questionnaireData={questionnaireData}
                  personalData={personalData}
                />
              ) : (
                ''
              )}
              <div className={classes.buttons}>
                {plannerStep !== 1 && plannerStep !== 4 ? (
                  <button
                    className="btn turquoise-btn"
                    onClick={handleClickReturn}
                  >
                    Poprzedni krok
                  </button>
                ) : (
                  <p></p>
                )}

                {plannerStep !== 4 ? (
                  <button
                    className="btn blue-btn"
                    onClick={handleClick}
                    // disabled={!isFormValid}
                  >
                    Następny krok
                  </button>
                ) : (
                  <p></p>
                )}
              </div>
            </div>
            {plannerStep === 4 ? (
              <div className={classes.summaryBoxes}>
                <div className="box-wrapper">
                  <img src={download} alt="" />
                  <h5>Pobierz lub wydrukuj podsumowanie</h5>

                  <PDFDownloadLink
                    document={
                      <BasicDocument
                        cart={cart}
                        personalData={personalData}
                        questionnaireData={questionnaireData}
                      />
                    }
                    fileName="podsumowanie.pdf"
                  >
                    {({ blob, url, loading, error }) =>
                      loading ? (
                        'Loading document...'
                      ) : (
                        <button class="btn border-btn">Podsumowanie</button>
                      )
                    }
                  </PDFDownloadLink>
                </div>
                <div className="box-wrapper">
                  <img src={contact} alt="" />
                  <h5>Pytania? Zadzwoń lub napisz do nas wiadomość!</h5>
                  <a
                    class="btn pink-border-btn"
                    href={'https://hullo.pl/kontakt/'}
                  >
                    Kontakt
                  </a>
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
};

export default App;
